// extracted by mini-css-extract-plugin
export default {"menuBlock":"VJ-z","title":"WJ-z","nav":"XJ-z","flexCell":"YJ-z","facetLink":"ZJ-z"};